import { render, staticRenderFns } from "./wikiTextScroll.vue?vue&type=template&id=1fd470bc"
import script from "./wikiTextScroll.vue?vue&type=script&lang=js"
export * from "./wikiTextScroll.vue?vue&type=script&lang=js"
import style0 from "./wikiTextScroll.vue?vue&type=style&index=0&id=1fd470bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports